import React from 'react';

const IconLogo = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M9.49997 12.4L5 17.7999"
        stroke="#e965e9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{' '}
      <path
        d="M9.49997 12.4L5 7"
        stroke="#e965e9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{' '}
      <line
        x1="18"
        y1="18"
        x2="10"
        y2="18"
        stroke="#e965e9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{' '}
    </g>
  </svg>
);

export default IconLogo;
